module.exports = __webpack_public_path__ + "static/media/piyush-goel.ba21f6b7.png";